import { useEffect, useState } from 'react';
import arrowDown from '../../../../images/arrowDown.svg';
import { FileComponent } from '../../../common/Dropzone/Dropzone';
import {
  ActionButton,
  CancelOrderButton,
} from '../../../common/Buttons/Buttons';
import {
  SalesOrderImageModal,
  ValidatePaymentFormOrderModal,
} from '../../../common/Modals/Modals';
import { MembershipLogo } from '../../../common/Cards/Cards';
import { capitalize, validateHasDebtOnAnulationOrder, displayMembershipCode } from '../../../../assets/helpers/funciones';
import {
  Select,
  ValidateCheckboxComponent,
} from '../../../common/Forms/Input/Input';
import { membershipService } from '../../../../services/membershipService';
import { notify } from '../../../../assets/helpers/toast';
import moment from 'moment';
import {
  CancelMembershipModal,
  ResendDocumentModal,
} from '../../../common/Modals/Modals';
import {
  membershipAnnulationOptions,
  planStatus,
} from '../../../../assets/helpers/options';
import { LoadSpinner } from '../../../common/LoadSpinner/LoadSpinner';
import authService from '../../../../services/authService';
import { salesRoles } from '../../../../assets/helpers/roles';
import plusZoom from '../../../../images/plusZoom.svg';
import minusZoom from '../../../../images/minusZoom.svg';
import closeIcon from '../../../../images/close.svg';
import { useHistory } from 'react-router-dom';
import './OrderComponent.scss';
import { paymentsService } from '../../../../services/paymentsService';

export const Comprobante = (props) => {
  const { label, src } = props;
  return (
    <p className="order-text-separation">
      <b>{label ? label + ':' : ''}</b>{' '}
      <a href={src} target="_blank" rel="noreferrer">
        Ver comprobante
      </a>
    </p>
  );
};

export const DocumentLink = (props) => {
  const { label, src } = props;

  if (src) {
    return (
      <a
        className="membership-document-link"
        href={src}
        target="_blank"
        rel="noreferrer"
      >
        <div>
          <h6>{label}</h6>
        </div>
      </a>
    );
  } else return null;
};

export const TextComponent = (props) => {
  const { label, text } = props;
  return (
    <p className="order-text-separation">
      <b>{label ? label + ':' : ''}</b> <span>{text}</span>
    </p>
  );
};

export const DiscountComponent = (props) => {
  const { code, amount, label } = props;
  return (
    <p className="order-text-separation">
      <b>{label ? label + ':' : ''}</b>{' '}
      <span>
        <b>{code}</b> {amount}
      </span>
    </p>
  );
};

export const OrderCard = (props) => {
  const { membership, refresh, isFromChangePaymentType } = props;
  const history = useHistory();
  const [verifiedPayment, setVerifiedPayment] = useState(false);
  const [verifiedDocument, setVerifiedDocument] = useState(false);
  const [saved, setSaved] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [groupedLinkedPayments, setGroupedLinkedPayments] = useState([]);
  const [validateModal, setValidateModal] = useState(false);
  const [showCancelService, setShowCancelService] = useState({
    show: false,
    caseSelected: '',
    cancelOptions: membershipAnnulationOptions,
  });

  const [resendModal, setResendModal] = useState({
    show: false,
    selected: '',
  });

  const [annulationReason, setAnnulationReason] = useState('');

  const isPendingDocumentation =
    membership?.membershipStatus === planStatus.PENDING_DOCUMENTATION;

  const approveMembership = () => {
    if (!isLoading) {
      setIsLoading(true);
      membershipService
        .approveMembership(membership?._id)
        .then((response) => {
          if ([200, 201].includes(response?.status)) {
            notify(`Membresia aprobada`, 'success');
            refresh();
            setTimeout(() => {
              setIsLoading(false);
            }, 1500);
          } else {
            setIsLoading(false);
            notify(`${response.message}`, 'error');
          }
        })
        .catch((error) => { });
    }
  };

  const reactivateMembership = () => {
    if (!isLoading) {
      setIsLoading(true);
      membershipService
        .reativateMembership(membership?._id)
        .then((response) => {
          if ([200, 201].includes(response?.status)) {
            setIsLoading(false);
            notify(`Membresia reactivada`, 'success');
            refresh();
          } else {
            setIsLoading(false);
            notify(`${response.message}`, 'error');
          }
        })
        .catch((error) => { });
    }
  };

  const updateMembership = () => {
    let data = {
      verifiedDocuments: verifiedDocument.toString(),
      verifiedPayment: verifiedPayment.toString(),
    };

    if (
      !isPendingDocumentation &&
      membership?.rcv !== 'N/A' &&
      !membership?.vehicle?.seats
    ) {
      notify(`Debe indicar la cantidad de asientos`, 'error');
      return null;
    }
    if (
      !isPendingDocumentation &&
      membership?.rcv !== 'N/A' &&
      !membership?.vehicle?.vehicleUsage
    ) {
      notify(`Debe indicar el uso del vehiculo`, 'error');
      return null;
    }

    if (!isLoading) {
      setIsLoading(true);
      membershipService
        .updateMembership(data, membership?._id)
        .then((response) => {
          if ([200, 201].includes(response?.status)) {
            setIsLoading(false);
            notify(`Cambios guardados`, 'success');
            refresh();
            setSaved(true);
          } else {
            setIsLoading(false);
            notify(`${response.message}`, 'error');
          }
        })
        .catch((error) => { });
    }
  };

  const handleCheckboxChange = (name) => {
    // Siblig membership cannot approve payment
    if (membership?.mainMembership?._id && name === 'Pago comprobado') {
      return null;
    }

    if (
      [
        salesRoles?.SALES_ADMIN,
        salesRoles?.SALES_DEVELOPER,
        salesRoles?.SALES_SUPERVISOR,
        salesRoles?.SALES_HUNTER,
        salesRoles?.SALES_FARMER,
        salesRoles?.SALES_COUNTER,
        salesRoles?.SALES_ADMIN_AUX,
        salesRoles?.EVENTS,
        salesRoles?.SALES_KEY_ACCOUNTS,
      ].includes(authService.getUserType())
    ) {
      if (name === 'Documentos comprobados') {
        setVerifiedDocument(!verifiedDocument);
        setSaved(false);
      }
    }

    if (
      ![
        salesRoles?.SALES_SUPERVISOR,
        salesRoles?.SALES_HUNTER,
        salesRoles?.SALES_FARMER,
        salesRoles?.SALES_COUNTER,
        salesRoles?.EVENTS,
        salesRoles?.SALES_KEY_ACCOUNTS,
      ].includes(authService.getUserType())
    ) {
      if (name === 'Pago comprobado') {
        if (verifiedPayment) {
          setVerifiedPayment(false);
        } else {
          checkLinkedMemberships(membership?.payments)
            .then((grouped) => {
              if (!grouped || grouped.length === 0) {
                setVerifiedPayment(true);
              } else {
                setValidateModal(true);
              }
            })
            .catch(() => { });
        }
      }
    }
    setSaved(false);
  };

  const changeAnnulationReason = () => {
    if (!isLoading && annulationReason && annulationReason !== membership?.annulationReason) {
      setIsLoading(true);
      membershipService
        .changeAnnullationReason({ reason: annulationReason }, membership?._id)
        .then((response) => {
          if ([200, 201].includes(response?.status)) {
            setIsLoading(false);
            notify(`Motivo de anulación actualizado`, 'success');
            refresh();
          } else {
            setIsLoading(false);
            notify(`${response.message}`, 'error');
          }
        })
        .catch((error) => {
          setIsLoading(false);
        });
    }
  };

  const handleCancelModal = () => {
    setShowCancelService((prevState) => {
      return {
        ...prevState,
        show: !showCancelService?.show,
        caseSelected: membership ? membership : '',
      };
    });
  };

  const preloadForm = () => {
    setVerifiedDocument(
      membership?.verifiedDocuments ? membership?.verifiedDocuments : false
    );
    setVerifiedPayment(
      membership?.verifiedPayment ? membership?.verifiedPayment : false
    );

    if (membership?.verifiedDocuments && membership?.verifiedPayment) {
      setSaved(true);
    }

    setAnnulationReason(membership?.annulationReason || '');
  };

  const sendDocuments = () => {
    if (!isLoading) {
      setIsLoading(true);
      membershipService
        .sendDocuments(resendModal?.selected)
        .then((response) => {
          if ([200, 201].includes(response?.status)) {
            setIsLoading(false);
            notify(`Documentos enviados`, 'success');
            handleResendModal();
          } else {
            setIsLoading(false);
            notify(`${response.message}`, 'error');
          }
        })
        .catch((error) => { });
    }
  };

  const handleResendModal = (membershipId) => {
    setResendModal((prevState) => {
      return {
        ...prevState,
        show: !resendModal?.show,
        selected: membershipId ? membershipId : '',
      };
    });
  };

  const groupPaymentsByReference = (response, actualmembership) => {
    const memberships = response?.data?.memberships || [];
    const map = new Map();

    for (const m of memberships) {
      const membershipId = m;
      if (!Array.isArray(m.payments)) continue;

      for (const p of m.payments) {
        const ref = (p.reference ?? '').toString();

        // Saltar si es la membresía actual
        if (membershipId.membershipId === actualmembership) continue;

        if (!map.has(ref)) map.set(ref, new Set());
        map.get(ref).add({
          membershipId: membershipId.membershipId,
          _id: membershipId._id,
        });
      }
    }

    return Array.from(map.entries()).map(([reference, set]) => ({
      payment: reference,
      memberships: Array.from(set),
    }));
  };

  const checkLinkedMemberships = async (payment) => {
    try {
      if (!payment || (Array.isArray(payment) && payment.length === 0)) {
        setGroupedLinkedPayments([]);
        return [];
      }

      setIsLoading(true);

      const payments = [];
      // accept either an array of payments or a single payment object
      const toIterate = Array.isArray(payment) ? payment : [payment];
      toIterate.forEach((pay) => {
        payments.push({
          method: pay?.methodId ?? pay?.method ?? null,
          reference: pay?.reference ?? null,
        });
      });

      const response = await paymentsService.checkLinkedPayments({ payments });

      if (response && response.status === 200) {
        const grouped = groupPaymentsByReference(
          response,
          membership?.membershipId
        );
        setGroupedLinkedPayments(grouped);
        setIsLoading(false);
        return grouped;
      }

      setIsLoading(false);
      return [];
    } catch (error) {
      setIsLoading(false);
      return [];
    }
  };

  useEffect(() => {
    preloadForm();
  }, []);

  const openClientPortalRegistration = () => {
    const clientId = membership?.customer?._id;
    const portal = process.env.REACT_APP_CLIENT_PORTAL;

    if (!clientId) {
      notify('No se encontró el cliente', 'error');
      return;
    }

    if (!portal) {
      notify('Portal de cliente no configurado', 'error');
      return;
    }

    const baseUrl = portal.startsWith('http') ? portal : `http://${portal}`;
    window.open(
      `${baseUrl.replace(/\/$/, '')}/pending-affiliation?clientId=${clientId}`,
      '_blank'
    );
  };

  return (
    <>
      <LoadSpinner show={isLoading} />
      <CancelMembershipModal
        showCancelService={showCancelService}
        handleClose={() => handleCancelModal()}
        refresh={refresh}
      />

      <ValidatePaymentFormOrderModal
        linkedMemberships={groupedLinkedPayments}
        isOpen={validateModal}
        closeModal={() => {
          setValidateModal(false);
          setVerifiedPayment(false);
        }}
        action={() => {
          setVerifiedPayment(true);
          setValidateModal(false);
        }}
      />

      <ResendDocumentModal
        show={resendModal?.show}
        handleClose={handleResendModal}
        action={sendDocuments}
      />

      <div className={`card detail-order-card`}>
        <h5>Detalle de la Orden</h5>

        <MembershipOrdeCardHeader membership={membership} />

        <div style={{ width: '100%' }} className="row card-row-container">
          <div style={{ padding: '0px' }} className="col-2">
            {/* <MembershipLogo code={_case?.membership?.code?.code} /> */}
          </div>
          <br />
          <div className="col-12">
            {membership?.payments?.map((p, i) => {
              let igtf = '';
              if (p?.currency !== 'BsS') {
                igtf = ' Incluye IGTF';
              }
              return (
                <div key={p?.method}>
                  <TextComponent
                    label={'Método'}
                    text={capitalize(p?.method)}
                  />
                  <TextComponent
                    label={`Pago ${i + 1} ${membership?.payments[i]?.upgrade ? '(Upgrade)' : ''
                      } USD`}
                    text={
                      p?.totalAmount
                        ? (p?.totalAmount + (p?.igtfAmount || 0)).toFixed(2)
                        : membership?.priceInfo?.finalPrice.toFixed(2) +
                        ' USD' +
                        igtf
                    }
                  />
                  {p?.reference && (
                    <TextComponent label={'Referencia'} text={p?.reference} />
                  )}
                  <Comprobante src={p?.referenceImg} />
                </div>
              );
            })}
            {membership?.discountCode && (
              <DiscountComponent
                label={'Cupon'}
                code={`(${membership?.discountCode})`}
                amount={`${membership?.priceInfo?.discountByCode} USD`}
              />
            )}
            {membership?.giftcardCode && (
              <DiscountComponent
                label={`Tarjeta`}
                code={`(${membership?.giftcardCode})`}
                amount={`${membership?.priceInfo?.discountByGiftcard} USD`}
              />
            )}

            {membership?.beginDate && (
              <TextComponent
                label={'Inicio del Plan'}
                text={moment(membership?.beginDate).format('DD/MM/YYYY')}
              />
            )}
            {membership?.startRcv && (
              <TextComponent
                label={'Inicio RCV'}
                text={moment(membership?.startRcv).format('DD/MM/YYYY')}
              />
            )}

            {membership?.endDate && (
              <TextComponent
                label={'Culminación del Plan'}
                text={moment(membership?.endDate).format('DD/MM/YYYY')}
              />
            )}
            {membership?.endRcv && (
              <TextComponent
                label={'Culminación del RCV'}
                text={moment(membership?.endRcv).format('DD/MM/YYYY')}
              />
            )}
          </div>

          {!isFromChangePaymentType && (
            <>
              {!['ANULADO', 'DENEGADO']?.includes(
                membership?.membershipStatus
              ) && (
                  <CancelOrderButton
                    label={'Anular Orden'}
                    action={handleCancelModal}
                  />
                )}
              {['PENDIENTE DE APROBACION', 'DOCUMENTACIÓN PENDIENTE'].includes(membership?.membershipStatus) && (
                <>
                  <ValidateCheckboxComponent
                    label={'Pago comprobado'}
                    selected={verifiedPayment}
                    onSelect={handleCheckboxChange}
                  />
                </>
              )}

              {['PENDIENTE DE APROBACION'].includes(membership?.membershipStatus) && (
                <>
                  <ValidateCheckboxComponent
                    label={'Documentos comprobados'}
                    selected={verifiedDocument}
                    onSelect={handleCheckboxChange}
                  />
                </>
              )}

              {![
                planStatus?.PENDING_FOR_APPROBAL,
                planStatus?.CANCELED,
                planStatus?.INCOMPLETED,
                planStatus?.PENDING_DOCUMENTATION,
              ].includes(membership?.membershipStatus) && (
                  <div
                    style={{ marginTop: '12px' }}
                    className="buttons-center-container"
                  >
                    <ActionButton
                      label={'Reenviar Documentos'}
                      action={() => handleResendModal(membership?._id)}
                    />
                  </div>
                )}
              {isPendingDocumentation && (
                <div
                  style={{ marginTop: '12px' }}
                  className="buttons-center-container"
                >
                  <ActionButton
                    label={'Completar registro'}
                    action={openClientPortalRegistration}
                  />
                </div>
              )}
              {!isPendingDocumentation && (
                <div
                  style={{ marginTop: '12px' }}
                  className="buttons-center-container"
                >
                  <ActionButton
                    label={'Ver RCV'}
                    action={() => history.push(`/rcv/${membership?._id}`)}
                  />
                </div>
              )}

              {![planStatus?.INCOMPLETED]?.includes(
                membership?.membershipStatus
              ) && (
                  <>
                    <div className="membership-document-link-container">
                      <DocumentLink
                        label={'Ver cuadro Producto'}
                        src={membership?.documents?.contract}
                      />
                      {!isPendingDocumentation && (
                        <>
                          <DocumentLink
                            label={'Ver poliza RCV'}
                            src={membership?.documents?.rcv}
                          />
                          <DocumentLink
                            label={'Ver carnet RCV'}
                            src={membership?.documents?.rcvCard}
                          />
                        </>
                      )}
                    </div>
                    {!isPendingDocumentation && (
                      <div className="membership-document-link-container">
                        <DocumentLink
                          label={'Ver Carnet Imprimible'}
                          src={membership?.documents?.printableCard}
                        />
                      </div>
                    )}
                  </>
                )}

              {['ANULADO', 'DENEGADO']?.includes(
                membership?.membershipStatus
              ) && (
                  <h6 className="oder-anulation-reason">
                    Motivo de Anulación: {membership?.annulationReason}
                  </h6>
                )}

              {['ANULADO', 'DENEGADO']?.includes(
                membership?.membershipStatus
              ) &&
                [salesRoles?.SALES_ADMIN, salesRoles?.SALES_SUPERVISOR].includes(
                  authService.getUserType()
                ) && (
                  <>
                    <Select
                      label={'Cambiar Motivo de Anulación'}
                      options={membershipAnnulationOptions}
                      value={annulationReason}
                      onChange={(e) => setAnnulationReason(e.target.value)}
                    />
                    {annulationReason !== membership?.annulationReason && (
                      <div
                        style={{ marginTop: '12px' }}
                        className="buttons-center-container"
                      >
                        <ActionButton
                          label={'Guardar Motivo'}
                          action={changeAnnulationReason}
                        />
                      </div>
                    )}
                  </>
                )}
              <div
                style={{ marginTop: '12px' }}
                className="buttons-center-container"
              >
                {['PENDIENTE DE APROBACION', 'DOCUMENTACIÓN PENDIENTE'].includes(membership?.membershipStatus) &&
                  !saved &&
                  (verifiedDocument || verifiedPayment ? (
                    <ActionButton
                      label={'Guardar'}
                      action={() => updateMembership()}
                    />
                  ) : (
                    ''
                  ))}

                {membership?.membershipStatus === 'PENDIENTE DE APROBACION' &&
                  saved &&
                  (verifiedDocument && verifiedPayment ? (
                    <ActionButton
                      label={
                        membership?.affiliationType === 'Renovación'
                          ? 'Renovar Orden'
                          : 'Aprobar Orden'
                      }
                      action={() => approveMembership()}
                    />
                  ) : (
                    ''
                  ))}

                {['ANULADO', 'DENEGADO']?.includes(
                  membership?.membershipStatus
                ) &&
                  membership?.annulationReason !== 'Cliente moroso ventas' &&
                  validateHasDebtOnAnulationOrder(membership) && (
                    <ActionButton
                      label={'Reactivar Orden'}
                      action={() => reactivateMembership()}
                    />
                  )}

              </div>
            </>
          )}

        </div>
      </div>
    </>
  );
};

export const MembershipOrdeCardHeader = (props) => {
  const { membership } = props;
  return (
    <div className="card-membership-name-info">
      <div className="row">
        <div className="col-4 col-md-12">
          <div className="card-membership-name-info-logo-container">
            <MembershipLogo code={membership?.membershipPlan} />
          </div>
        </div>
        <div className="col-2 col-md-6 center-component">
          <p>
            <b>Plan:</b>
            <br />
            {displayMembershipCode(membership?.membershipPlan)}
          </p>
        </div>
        <div className="col-6 col-md-6 center-component">
          <p>
            <b>Costo del Plan:</b>
            <br />
            {membership?.priceInfo?.finalPrice.toFixed(2)}$
          </p>
        </div>
      </div>
    </div>
  );
};

export const OderCardHeader = (props) => {
  const { open, setOpen, label } = props;

  return (
    <div className="order-card-header">
      <div>
        <h5>{label}</h5>
      </div>
      {!open ? (
        <img
          style={{ rotate: '-90deg' }}
          className="arrow-down"
          src={arrowDown}
          alt="arrowDown"
          onClick={() => setOpen(!open)}
        />
      ) : (
        <img
          className="arrow-down"
          src={arrowDown}
          alt="arrowDown"
          onClick={() => setOpen(!open)}
        />
      )}
    </div>
  );
};

export const DocumentImageComponent = (props) => {
  const { showDocumetModal, openDocumentModal, zoomDocumentModal } = props;

  return (
    <div
      style={{
        height: 500 * showDocumetModal?.zoom,
        width: 500 * showDocumetModal?.zoom,
      }}
      className="document-image-component"
    >
      <div className="document-image-component-header">
        <div>
          <img
            onClick={() => zoomDocumentModal(1.3)}
            src={plusZoom}
            alt="plusZoom"
          />
          <img
            onClick={() => zoomDocumentModal(1)}
            src={minusZoom}
            alt="minusZoom"
          />
        </div>
        <div>
          <img
            onClick={() => openDocumentModal()}
            src={closeIcon}
            alt="closeIcon"
          />
        </div>
      </div>

      {showDocumetModal?.src.includes('pdf') ? (
        <iframe
          title='document pdf'
          className="image-container-iframe"
          src={showDocumetModal?.src}
        ></iframe>
      ) : (
        <img src={showDocumetModal?.src} alt="document" />
      )}
    </div>
  );
};

export const OrdeCard = (props) => {
  const { label, membership, refresh } = props;
  const [open, setOpen] = useState(true);
  const [showDocumetModal, setShowDocumetModal] = useState({
    show: false,
    src: '',
    zoom: 1,
  });
  const [showImageModal, setShowImageModal] = useState({
    isOpen: false,
    label: '',
    tag: '',
    message: '(PNG, JPG, JEPG, máx. 3MB)',
    selected: '',
  });

  const openDocumentModal = (src) => {
    setShowDocumetModal((prevState) => {
      return {
        ...prevState,
        show: !showDocumetModal?.show,
        src: !showDocumetModal?.src ? src : '',
      };
    });
  };

  const zoomDocumentModal = (zoom) => {
    setShowDocumetModal((prevState) => {
      return {
        ...prevState,
        zoom: zoom,
      };
    });
  };

  const opeImageModal = (label, tag, payment) => {
    setShowImageModal((prevState) => {
      return {
        ...prevState,
        isOpen: true,
        label: label,
        tag: tag,
        message: '(PNG, JPG, JEPG, máx. 3MB)',
        payment: payment,
        selected: membership?._id,
      };
    });
  };

  const closeImageModal = () => {
    setShowImageModal((prevState) => {
      return {
        ...prevState,
        isOpen: false,
        label: '',
        tag: '',
        message: '(PNG, JPG, JEPG, máx. 3MB)',
        selected: '',
      };
    });
  };
  return (
    <>
      {showDocumetModal?.show && (
        <DocumentImageComponent
          showDocumetModal={showDocumetModal}
          openDocumentModal={openDocumentModal}
          zoomDocumentModal={zoomDocumentModal}
        />
      )}
      <div className="order-card">
        <SalesOrderImageModal
          imageModal={showImageModal}
          closeImageModal={closeImageModal}
          refresh={refresh}
        />
        <OderCardHeader open={open} setOpen={setOpen} label={label} />
        <br />
        {open && (
          <div style={{ width: '100%' }} className="row">
            <div className="col-12 col-md-4">
              <OrderImageComponent
                name={'Cedula'}
                tag={'identityDocument'}
                src={membership?.customer?.identityDocument}
                opeImageModal={opeImageModal}
                openDocumentModal={openDocumentModal}
              />
            </div>
            <div className="col-12 col-md-4">
              <OrderImageComponent
                name={'Licencia'}
                tag={'license'}
                src={
                  membership?.customer?.licenses?.length > 0
                    ? membership?.customer?.licenses[0]
                    : ''
                }
                opeImageModal={opeImageModal}
                openDocumentModal={openDocumentModal}
              />
            </div>
            <div className="col-12 col-md-4">
              <OrderImageComponent
                // name={'Carnet de Circulación'}
                name={'Título de propiedad del vehículo'}
                tag={'circulationCard'}
                src={membership?.vehicle?.circulationCard}
                opeImageModal={opeImageModal}
                openDocumentModal={openDocumentModal}
              />
            </div>

            {membership?.payments?.map((m, i) => {
              return (
                <div key={m?._id} className="col-12 col-md-4">
                  <OrderImageComponent
                    name={`Comprobante de Pago (${i + 1})`}
                    tag={`payment1`}
                    payment={m}
                    src={m?.referenceImg}
                    opeImageModal={opeImageModal}
                    openDocumentModal={openDocumentModal}
                  />
                </div>
              );
            })}
          </div>
        )}
      </div>
    </>
  );
};

export const OrderImageComponent = (props) => {
  const { name, src, payment, opeImageModal, tag, openDocumentModal } = props;

  return (
    <div style={{ margin: '48px 24px' }}>
      <FileComponent file={{ name: name }} />
      <div className="buttons-center-container">
        {src && (
          // <a target="_blank" href={src}>
          <ActionButton label={'Ver'} action={() => openDocumentModal(src)} />
          // </a>
        )}
        <ActionButton
          label={src ? 'Cambiar' : 'Agregar'}
          action={() => opeImageModal(name, tag, payment)}
        />
      </div>
    </div>
  );
};

export const RCVOrderCard = (props) => {
  const { membership, refresh, amount } = props;

  const [verifiedPayment, setVerifiedPayment] = useState(false);
  const [verifiedDocument, setVerifiedDocument] = useState(false);
  const [saved, setSaved] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const approveMembership = () => {
    if (!isLoading) {
      setIsLoading(true);
      membershipService
        .approveMembership(membership?._id)
        .then((response) => {
          if ([200, 201].includes(response?.status)) {
            notify(`Membresia aprobada`, 'success');
            refresh();
            setTimeout(() => {
              setIsLoading(false);
            }, 1500);
          } else {
            setIsLoading(false);
            notify(`${response.message}`, 'error');
          }
        })
        .catch((error) => { });
    }
  };

  const preloadForm = () => {
    setVerifiedDocument(
      membership?.verifiedDocuments ? membership?.verifiedDocuments : false
    );
    setVerifiedPayment(
      membership?.verifiedPayment ? membership?.verifiedPayment : false
    );

    if (membership?.verifiedDocuments && membership?.verifiedPayment) {
      setSaved(true);
    }
  };

  useEffect(() => {
    preloadForm();
  }, []);

  return (
    <>
      <LoadSpinner show={isLoading} />

      <div className={`card detail-order-card`}>
        <h5>Detalle de la Orden</h5>

        <div className="card-membership-name-info">
          <div className="row">
            <div className="col-4 col-md-12">
              <div className="card-membership-name-info-logo-container"></div>
            </div>
            <div className="col-2 col-md-6 center-component">
              <p>
                <b>Clase de Vehículo:</b>
                <br />
                {capitalize(membership?.vehicle?.class)}
              </p>
            </div>
            <div className="col-6 col-md-6 center-component">
              <p>
                <b>Precio:</b>
                <br />
                {amount}
              </p>
            </div>
          </div>
        </div>

        <div style={{ width: '100%' }} className="row card-row-container">
          <div style={{ padding: '0px' }} className="col-2"></div>

          <div
            style={{ marginTop: '12px' }}
            className="buttons-center-container"
          >
            {membership?.membershipStatus === 'PENDIENTE DE APROBACION' &&
              saved &&
              (verifiedDocument && verifiedPayment ? (
                <ActionButton
                  label={
                    membership?.affiliationType === 'Renovación'
                      ? 'Renovar Orden'
                      : 'Aprobar Orden'
                  }
                  action={() => approveMembership()}
                />
              ) : (
                ''
              ))}
          </div>
        </div>
      </div>
    </>
  );
};
